import { useState } from "react";
import { TABLET_SIZE } from "../../../../../../core/constants/common";
import { useWindowSize } from "../../../../../../core/hooks/common/useWindowSize";
import UserBalanceHistoryTable from "./UserBalanceHistoryTable";
import FilterLayout from "../../../../../layout/filter/FilterLayout";
import { useGetUserBalanceHistory } from "../../../../../../core/services/react-query/report/cards";
import { CacheKeys, userBalanceHistoryOptions } from "../../../../../../core/constants/filter";
import { UserDetailListWrapper } from "../../../../../../styles/main/user";
import RUserBalanceHistoryTable from "./RUserBalanceHistoryTable";


const UserBalanceHistory = ({ userId }) => {

    const { width } = useWindowSize();
    const [transactions, setTransactions] = useState({ loading: true, data: null })
    const onQuerySuccess = (res) => {
        setTransactions(res)
    }

    const Component = width > TABLET_SIZE ? UserBalanceHistoryTable : RUserBalanceHistoryTable


    return (
        <UserDetailListWrapper>
            <FilterLayout
                query={useGetUserBalanceHistory}
                options={userBalanceHistoryOptions}
                onQuerySuccess={onQuerySuccess}
                cache={CacheKeys.USER_BALANCE_HISTORY}
                extra={{ userId: userId }}
            >
                <Component
                    data={transactions}
                />
            </FilterLayout >
        </UserDetailListWrapper>
    )
}

export default UserBalanceHistory